export default __webpack_public_path__ + "static/9-e8f4fe2bfddf65d54a8a490a3878811a.jpg";